import type { ProductBlockDataModel } from "./subscription-builder.types";

export const fetchProductBlockDataService = (blockId: string): Promise<ProductBlockDataModel> => {
  return fetch(`/api/subscriptionbuilder/GetSubscriptionBlock?blockId=${blockId}`)
    .then((res) => res.json())
    .then((data: ProductBlockDataModel) => {
      return data;
    });
};
